import { useContext } from 'react'
import { ExZeroContext, ExZeroContextInterface } from './exzero-context'

const useExZero = (context = ExZeroContext): ExZeroContextInterface =>
  useContext(context) as ExZeroContextInterface

export default useExZero
